import { l as e, u as t } from "./useVoiceUpload-Db2XyZN1.js";
import { ComponentIdentifierEnum as n, FormFieldsEnum as r, notifySuspenseEnded as i, notifySuspenseStarted as a } from "@flowx/core-sdk";
import { lazy as o, memo as s, useCallback as ee, useLayoutEffect as c, useState as l } from "react";
import { clsx as te } from "clsx";
import { usePositionStyles as u, useWrapperStyles as ne } from "@flowx/react-theme";
import { jsx as d } from "react/jsx-runtime";
// libs/sdk/react/src/lib/utils/lazyWithPreload.tsx
var f = (e) => {
	let t, n, r = () => n ??= e().then((e) => t = e, (e) => {
		throw n = void 0, e;
	}), i = o(r);
	return Object.assign(s((e) => {
		let [n] = l(() => t?.default ?? i);
		return /* @__PURE__ */ d(n, { ...e });
	}), { preload: r });
}, p = f(() => import("./FlxPage-Cl4Z3_v5.js"));
p.displayName = "LazyFlxPage";
var m = f(() => import("./FlxContainer-ZZR6HGaX.js"));
m.displayName = "LazyFlxContainer";
var h = f(() => import("./FlxButtonWrapper-BWMYa4dI.js"));
h.displayName = "MemoFlxButtonWrapper";
var g = f(() => import("./FlxLink-h3znDM5K.js"));
g.displayName = "MemoFlxLink";
var _ = f(() => import("./FlxMessage-D3qoxW9i.js"));
_.displayName = "LazyFlxMessageWrapper";
var v = f(() => import("./FlxSeparatorWrapper-zjMKvF0h.js"));
v.displayName = "LazyFlxSeparatorWrapper";
var y = f(() => import("./FlxProgressBarWrapper-CYMJfFWk.js"));
y.displayName = "LazyFlxProgressBarWrapper";
var b = f(() => import("./FlxTooltipWrapper-C4BZUpcF.js"));
b.displayName = "LazyFlxTooltipWrapper";
var x = f(() => import("./FlxMarkdownWrapper-BCJz745E.js"));
x.displayName = "LazyFlxMarkdownWrapper";
var S = f(() => import("./FlxChatWrapper-DWjf0z5o.js").then((e) => e.n));
S.displayName = "LazyFlxChatWrapper";
var C = f(() => import("./FlxText-mI6ZAgdq.js"));
C.displayName = "MemoFlxTextWrapper";
var w = f(() => import("./FlxFileUploadWrapper-BL4PZNoa.js"));
w.displayName = "LazyFlxFileUploadWrapper";
var T = f(() => import("./FlxBulkFileUploadWrapper-CyK-oAll.js"));
T.displayName = "LazyFlxBulkFileUploadWrapper";
var E = f(() => import("./FlxDownloadWrapper-D4-_XCYa.js"));
E.displayName = "LazyFlxDownloadWrapper";
var D = f(() => import("./FlxCardWrapper-TjP5RWCC.js"));
D.displayName = "LazyFlxCardWrapper";
var O = f(() => import("./FlxImage-DkVJooMY.js"));
O.displayName = "LazyFlxImageWrapper";
var k = f(() => import("./FlxDocumentViewerWrapper-BI77uNRC.js"));
k.displayName = "LazyFlxDocumentViewerWrapper";
var A = f(() => import("./FlxForm-C7VSn-Ol.js"));
A.displayName = "LazyFlxFormWrapper";
var j = f(() => import("./FlxInputWrapper-84bDlauZ.js"));
j.displayName = "LazyFlxInputWrapper";
var M = f(() => import("./FlxTextAreaWrapper-Da_bHYqq.js"));
M.displayName = "LazyFlxTextAreaWrapper";
var N = f(() => import("./FlxSelectWrapper-264kFxNN.js"));
N.displayName = "LazyFlxSelectWrapper";
var P = f(() => import("./FlxMultiSelectWrapper-qwGspFe8.js"));
P.displayName = "LazyFlxMultiSelectWrapper";
var F = f(() => import("./FlxRadioGroupWrapper-uCR7P2hy.js"));
F.displayName = "LazyFlxRadioGroupWrapper";
var I = f(() => import("./FlxCheckboxGroupWrapper-5ip7_U69.js"));
I.displayName = "LazyFlxCheckboxGroupWrapper";
var L = f(() => import("./FlxSwitchWrapper-B19rJhH6.js"));
L.displayName = "LazyFlxSwitchWrapper";
var R = f(() => import("./FlxDatePickerWrapper-Vj0kadxO.js"));
R.displayName = "LazyFlxDatePickerWrapper";
var z = f(() => import("./FlxSliderWrapper-DWfg7MOs.js"));
z.displayName = "LazyFlxSliderWrapper";
var B = f(() => import("./FlxSegmentedButtonWrapper-CuV0THww.js"));
B.displayName = "LazyFlxSegmentedButtonWrapper";
var V = f(() => import("./FlxCollection-C56aHSs-.js"));
V.displayName = "LazyFlxCollection";
var H = f(() => import("./FlxCollectionPrototype-DpvZ4qSM.js"));
H.displayName = "LazyFlxCollectionPrototype";
var U = f(() => import("./src-DhzXnXB4.js").then((e) => e.N));
U.displayName = "LazyFlxModalWrapper";
var W = f(() => import("./FlxTabBarWrapper-CtKiyKhX.js"));
W.displayName = "LazyFlxTabBarWrapper";
var G = f(() => import("./FlxStepperWrapper-Tyus6YeD.js"));
G.displayName = "LazyFlxStepperWrapper";
var K = f(() => import("./FlxTableWrapper-yDMdZG8R.js"));
K.displayName = "LazyFlxTableWrapper";
var q = f(() => import("./FlxTaskManagementWrapper-rcdZ489s.js"));
q.displayName = "LazyFlxTaskManagementWrapper";
var J = f(() => import("./FlxProcessRendererWrapper-Cg9Bg532.js"));
J.displayName = "LazyFlxProcessRendererWrapper";
var re = f(() => import("./src-DhzXnXB4.js").then((e) => e.B).then((e) => ({ default: e.FlxRuntimeCustomComponent })));
re.displayName = "LazyFlxRuntimeCustomComponent";
var Y = {
	[n.LINK]: g,
	[n.BUTTON]: h,
	[n.MESSAGE]: _,
	[n.SEPARATOR]: v,
	[n.TOOLTIP]: b,
	[n.PROGRESS_BAR]: y,
	[n.MARKDOWN]: x,
	[n.CHAT]: S,
	[n.TEXT]: C,
	[n.FILE_UPLOAD]: w,
	[n.FILE_DOWNLOAD]: E,
	[n.BULK_FILE_UPLOAD]: T,
	[n.IMAGE]: O,
	[n.DOCUMENT_PREVIEW]: k,
	[n.FORM]: A,
	[n.TASK_MANAGEMENT]: q,
	[n.PROCESS_RENDERER]: J
}, X = {
	[n.PAGE]: p,
	[n.CONTAINER]: m,
	[n.CARD]: D,
	[n.COLLECTION]: V,
	[n.COLLECTION_PROTOTYPE]: H,
	[n.MODAL]: U,
	[n.TAB_BAR]: W,
	[n.ZONE]: m,
	[n.STEPPER]: G,
	[n.TABLE]: K
}, Z = {
	[r.INPUT]: j,
	[r.TEXTAREA]: M,
	[r.SELECT]: N,
	[r.MULTI_SELECT]: P,
	[r.RADIO]: F,
	[r.CHECKBOX]: I,
	[r.SWITCH]: L,
	[r.DATEPICKER]: R,
	[r.SLIDER]: z,
	[r.SEGMENTED_BUTTON]: B
}, Q = (e = []) => e.flatMap((e) => [e.componentIdentifier, ...Q(e.templateConfig)]), ie = {
	...X,
	...Y,
	...Z
}, ae = (e) => Promise.allSettled([...new Set(Q(e).map((e) => ie[e]))].map((e) => e?.preload).filter((e) => e !== void 0).map((e) => e())), oe = (e) => {
	if (!("displayOptions" in e)) return {};
	let t = e.displayOptions.style;
	return "componentIdentifier" in e && e.componentIdentifier === n.CHAT && t?.fill || t;
}, $ = ({ config: n, children: r, ref: i }) => {
	let a = oe(n), { className: o, ref: s } = ne({
		styles: a,
		componentIdentifier: "componentIdentifier" in n ? n.componentIdentifier : void 0
	}), c = ee((e) => {
		s(e), typeof i == "function" ? i(e) : i && (i.current = e);
	}, [s, i]), l = u({ styles: a?.position || null }), f = t({
		config: n,
		expression: "displayOptions" in n && "flowxProps" in n.displayOptions && n.displayOptions.flowxProps?.hide || "",
		logType: "hide"
	}), p = e(n);
	return f || p ? null : /* @__PURE__ */ d("div", {
		ref: c,
		className: te(o, l),
		children: r
	});
};
$.displayName = "FlxTreeNodeWrapper";
// libs/sdk/react/src/components/sdk/tree-node/SuspensePending.tsx
function se({ children: e = null }) {
	return c(() => (a(), i), []), e;
}
export { Z as a, X as i, $ as n, ae as o, Y as r, se as t };
